export const CHECKING_BALANCE_CLICK_EVENT = 'Banking: Banking Launcher Checking Account';
export const LAUNCHPAD_PAGE_LOAD_EVENT = 'Banking: Banking Launcher Homepage';
export const LEARN_CLICK_EVENT = 'Banking: Banking Launcher Learn';
export const LOAN_OFFER_CLICK_EVENT = 'Banking: Banking Launcher Loan Offer';
export const LOAN_CLICK_EVENT = 'Banking: Banking Launcher Loan';
export const SAVINGS_BALANCE_CLICK_EVENT = 'Banking: Banking Launcher Savings Account';
export const SAVINGS_CROSS_SELL_CLICK_EVENT = 'Banking: Banking Launcher Savings Xsell';
export const CHECKING_CROSS_SELL_CLICK_EVENT = 'Banking: Banking Launcher Checking Xsell';